import { REWARD_OFFERING } from "../constants";
import CompetitionPage from "../common/components/CompetitionPage";

function WeekThreeMain() {
  const offerId = REWARD_OFFERING.weekthree;

  return (
    <CompetitionPage 
      offerId={offerId}
    />
  );
}

export default WeekThreeMain;